videojs.addLanguage('ru', {
  "auto": "авто",
  "kbps": "кбит/с",
  "Quality": "Качество"
});